import { useCallback, useMemo } from "react";

import { useFilter } from "~/providers/FilterProvider";

export const useCategoriesFilterDropdown = () => {
  const { filters, updateFilters } = useFilter();

  const selectedValue = useMemo(
    () => filters.excludeCategoryIds ?? [],
    [filters.excludeCategoryIds]
  );

  const onChangeExcludeFilter = useCallback(
    (value?: string[]) => {
      updateFilters({
        excludeCategoryIds: value,
      });
    },
    [updateFilters]
  );

  return { selectedValue, onChangeExcludeFilter };
};
